/**
 * @generated SignedSource<<0f17430957319a950e3ed39946119a77>>
 * @relayHash f2ca726f801e136c279017d75f94f354
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c99df337881ad0bd838cfc9c883d111708944298487c6f13e76fc86b1fe58752

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraNotificationChannelType = "EMAIL" | "IN_PRODUCT" | "MOBILE_PUSH" | "SLACK" | "%future added value";
export type JiraNotificationType = "COMMENT_CREATED" | "COMMENT_DELETED" | "COMMENT_EDITED" | "DAILY_DUE_DATE_NOTIFICATION" | "ISSUE_ASSIGNED" | "ISSUE_CREATED" | "ISSUE_DELETED" | "ISSUE_MOVED" | "ISSUE_UPDATED" | "MENTIONS_COMBINED" | "MISCELLANEOUS_ISSUE_EVENT_COMBINED" | "PROJECT_INVITER_NOTIFICATION" | "WORKLOG_COMBINED" | "%future added value";
export type JiraUpdateGlobalNotificationPreferencesInput = {
  preferences: ReadonlyArray<JiraNotificationPreferenceInput>;
};
export type JiraNotificationPreferenceInput = {
  channel?: JiraNotificationChannelType | null | undefined;
  channelsEnabled?: ReadonlyArray<JiraNotificationChannelType> | null | undefined;
  isEnabled?: boolean | null | undefined;
  type: JiraNotificationType;
};
export type globalNotificationsConfigHead_HeadCheckbox_updateGlobalPreferencesMutation$variables = {
  cloudId: string;
  input: JiraUpdateGlobalNotificationPreferencesInput;
};
export type globalNotificationsConfigHead_HeadCheckbox_updateGlobalPreferencesMutation$data = {
  readonly jira: {
    readonly updateGlobalNotificationPreferences: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly preferences: {
        readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_allPreferences">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type globalNotificationsConfigHead_HeadCheckbox_updateGlobalPreferencesMutation = {
  response: globalNotificationsConfigHead_HeadCheckbox_updateGlobalPreferencesMutation$data;
  variables: globalNotificationsConfigHead_HeadCheckbox_updateGlobalPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = [
  {
    "kind": "ScalarField",
    "name": "channel"
  },
  {
    "kind": "ScalarField",
    "name": "isEnabled"
  },
  {
    "kind": "ScalarField",
    "name": "isEditable"
  }
],
v5 = [
  {
    "kind": "ScalarField",
    "name": "id"
  },
  {
    "kind": "ScalarField",
    "name": "type"
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "emailChannel",
    "plural": false,
    "selections": (v4/*: any*/)
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "inProductChannel",
    "plural": false,
    "selections": (v4/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "globalNotificationsConfigHead_HeadCheckbox_updateGlobalPreferencesMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_allPreferences"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "globalNotificationsConfigHead_HeadCheckbox_updateGlobalPreferencesMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueAssigned",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueUpdated",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueDeleted",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentEdited",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueCreated",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueMoved",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "mentionsCombined",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "worklogCombined",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "miscellaneousIssueEventCombined",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c99df337881ad0bd838cfc9c883d111708944298487c6f13e76fc86b1fe58752",
    "metadata": {},
    "name": "globalNotificationsConfigHead_HeadCheckbox_updateGlobalPreferencesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8675f86ca14bab97607ca1ee3141da84";

export default node;
